import { IOption } from '@/types/global.ts'
import { ReactNode, useRef } from 'react'
import usePopup from '@/shared/hooks/usePopup.ts'
import css from './colorDropdown.module.css'
import DropdownFadeInPanel from '@/shared/Dropdowns/DropdownFadeInPanel'
import DropdownListItem from '@/shared/Dropdowns/DropdownListItem'
import cn from '@/utils/cn.ts'

interface IProps {
  value: string
  name: string
  onChange: (val: string, name: string) => void
  icon?: ReactNode
}

export const defaultColorOptions: IOption<string>[] = [
  { title: 'Зеленый', value: '#52C41A' },
  { title: 'Темно-зеленый', value: '#135200' },
  { title: 'Желтый', value: '#FFC53D' },
  { title: 'Коричневый', value: '#AD6800' },
  { title: 'Красный', value: '#F5222D' },
  { title: 'Вишневый', value: '#820014' },
  { title: 'Голубой', value: '#36CFC9' },
  { title: 'Морская волна', value: '#006D75' },
  { title: 'Синий', value: '#1677FF' },
  { title: 'Темно-синий', value: '#002C8C' },
  { title: 'Лавандовый', value: '#B37FEB' },
  { title: 'Фиолетовый', value: '#722ED1' },
  { title: 'Розовый', value: '#F759AB' },
  { title: 'Маджента', value: '#C41D7F' },
  { title: 'Оранжевый', value: '#FF7A45' },
  { title: 'Золотой', value: '#D4B106' },
]

const ColorDropdown = (props: IProps) => {
  const ref = useRef<HTMLDivElement>(null)
  const { open, setOpen } = usePopup(ref)

  const renderOptions = () => {
    return defaultColorOptions.map((o) => (
      <DropdownListItem
        key={o.value}
        icon={<div className={css.circle} style={{ backgroundColor: o.value }} />}
        onClick={() => props.onChange(o.value, props.name)}
        active={o.value === props.value}
      >
        <p className="text-nm">{o.title}</p>
      </DropdownListItem>
    ))
  }

  return (
    <div ref={ref} style={{ position: 'relative' }} onClick={(ev) => ev.stopPropagation()} data-open={open}>
      <div className={cn({ [css.button]: !props.icon })} onClick={() => setOpen(true)} data-active={open}>
        {props.icon ? props.icon : <div className={css.circle} style={{ backgroundColor: props.value || '#000' }} />}
      </div>
      <DropdownFadeInPanel
        open={open}
        style={{ top: '36px', width: '220px' }}
        onClick={() => setOpen(false)}
        position="left"
      >
        {renderOptions()}
      </DropdownFadeInPanel>
    </div>
  )
}

export default ColorDropdown
